import Simulator from '../components/Simulator/Simulator';

const SimulatorPage = () => {
  return (
    <div className="w-full flex-1 bg-transparent p-5">
      <div className="mx-auto max-w-[1440px]">
        <Simulator />
      </div>
    </div>
  );
};

export default SimulatorPage;
